import { css } from '@emotion/react';
import { ReviewsTypes } from '@frontend/api-reviews';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { FacebookLegacyRatingIcon } from '../../icons/ratings/facebook-legacy-rating';
import { FacebookRecommendationIcon } from '../../icons/ratings/facebook-recommendation';

type Props = {
  rating?: number;
  recommendation?: ReviewsTypes.Recommendation;
};

export const FacebookRating = ({ rating = 0, recommendation, ...rest }: Props) => {
  const { t } = useTranslation('reviews');

  if (rating)
    return (
      <FacebookLegacyRatingIcon
        rating={rating}
        css={css`
          margin-right: ${theme.spacing(1)};
        `}
      />
    );

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
      `}
    >
      <FacebookRecommendationIcon active={recommendation === ReviewsTypes.Recommendation.Recommended} />
      <Text
        color='light'
        size='small'
        css={css`
          margin: ${theme.spacing(0, 1)};
        `}
        {...rest}
      >
        {recommendation === ReviewsTypes.Recommendation.Recommended ? t('Recommends') : t("Doesn't Recommend")}
      </Text>
    </div>
  );
};
